<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="Setting">
        <p-table [value]="crmSettingFieldsList" dataKey="id" [expandedRowKeys]="expandedRows">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Value</th>
                    <th style="width: 200px" class="p-text-right">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded">
                <tr>
                    <td>
                        {{product.name}}
                    </td>
                    <td>
                        <div class="p-d-flex p-ai-center">
                            {{product?.displayValue}}
                            <span *ngIf="['parentChildLevel','ContactTemplate'].includes(product?.code) && product.enabled" class="p-d-flex p-ai-center p-jc-center pi pi-pencil btnBars p-ml-2" pTooltip="Edit" tooltipPosition="top" (click)="editCsetting(product)">
                            </span>
                        </div>
                    </td>
                    <td class="p-text-right">
                        <p-inputSwitch (click)="changeCrmSeetings(product)" [(ngModel)]="product.enabled" [disabled]="['parentChildLevel'].includes(product?.code)"></p-inputSwitch>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-product>
                <ng-container *ngIf="product.code === 'WorkFlowUserAccess'">
                    <ng-container *ngFor="let control of accessControlData">
                        <tr>
                            <td></td>
                            <td>
                                <span class="p-ml-3">{{control.name}}</span>
                            </td>
                            <td class="action">
                                <ng-container class="p-field-radiobutton">
                                    <p-radioButton name="control" [value]="control" [(ngModel)]="selectedAccessControl" inputId="control1" (onClick)="saveAccessControl(control)">
                                    </p-radioButton>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-container>
            </ng-container>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <!-- <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu
                #configmenuOrders
                id="config_menu_orders"
                [model]="configMenuOrdersItems"
                [popup]="true"
                appendTo="body"
            >
            </p-menu>
            <span
                class="btnBars p-mr-0"
                (click)="configmenuOrders.toggle($event)"
            >
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel> -->
</p-tabView>


<p-dialog  styleClass="notes" [(visible)]="displaySettingsEdit" [modal]="true" [responsive]="true"  [style]="{width: '55%', minWidth: '55%'}" [closable]="false">
    <p-header>
        <h5 class="p-d-inline-block p-mb-0">
            {{ selectedSettings?.name }}
        </h5>
    </p-header>
    <div class="p-grid">
        <div class="p-col-12">
            <label for="channel">{{ settingsOptionValues?.[0]?.placeholder||'Select Option' }}</label>
            <p-dropdown id="channel" [options]="settingsOptionValues" optionLabel="name" placeholder="Select any" [(ngModel)]="selectedSettingOption" appendTo="body"></p-dropdown>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Close" (click)="displaySettingsEdit = false" class="p-button-secondary"></button>
        <button pButton label="Save"  (click)="saveSettings()" [disabled]="!selectedSettingOption"></button>
    </ng-template>
</p-dialog>
